"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eqRecursiveInterpreter = void 0;
var utils_1 = require("@morphic-ts/common/lib/utils");
var config_1 = require("../config");
var hkt_1 = require("../hkt");
/**
 *  @since 0.0.1
 */
exports.eqRecursiveInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.EqURI,
    recursive: function (a, _name, config) {
        var get = utils_1.memo(function () { return a(res); });
        var res = function (env) {
            return new hkt_1.EqType(config_1.eqApplyConfig(config)({ equals: function (a, b) { return get()(env).eq.equals(a, b); } }, env, {}));
        };
        return res;
    }
}); });
